import { Reveal, Eyebrow } from "@/components/site/Primitives";
import { SERVICES } from "@/data/site";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Services = () => {
  return (
    <section id="leistungen" className="relative py-24 lg:py-36 bg-cream-soft">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <Eyebrow>Leistungen</Eyebrow>
            <h2 className="mt-6 font-serif font-light tracking-tight text-charcoal text-4xl sm:text-5xl leading-tight">
              Behandlungen, die Ästhetik und Gesundheit vereinen
            </h2>
            <p className="mt-6 text-charcoal-soft leading-relaxed">
              Jede Behandlung wird individuell auf Sie abgestimmt – für natürliche Ergebnisse und ein
              nachhaltiges Wohlgefühl.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-6 gap-5 lg:auto-rows-[19rem]">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={s.span}>
              <article
                data-testid={`service-${s.id}`}
                className="group relative h-full min-h-[19rem] overflow-hidden rounded-[1.75rem] ring-1 ring-gold/20"
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/25 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-7">
                  <span className="text-[10px] uppercase tracking-luxe text-gold-soft">{s.tag}</span>
                  <h3 className="mt-2 font-serif text-2xl lg:text-3xl text-cream font-light">{s.title}</h3>
                  <p className="mt-3 text-sm text-cream/85 leading-relaxed max-w-md font-light">{s.text}</p>
                  <button
                    data-testid={`service-cta-${s.id}`}
                    onClick={() => scrollTo("kontakt")}
                    className="mt-5 self-start text-xs uppercase tracking-widest text-gold-soft border-b border-gold-soft/50 pb-1 hover:text-cream transition-colors duration-300"
                  >
                    Beratung anfragen
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
